import React, { useEffect, useState } from "react";
import Divider from 'theme/Divider';
import Text from "theme/Text";
import HelperDevelopment from 'utils/helper-development'
import { AppRoutes, MainAppRoutes } from 'navigations/app-routes'
import { StyleSheet, Pressable, View } from 'react-native'
import _ from "lodash"
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { colorList } from 'utils/colors'
import HelperVersion from 'utils/helper-version'
import AppUpdater from "services/app-updater";
import * as Progress from 'react-native-progress';
import CacheStorage from 'utils/cache/CacheStorage'
import HelperFileCache from 'utils/HelperFileCache'
import HelperString from 'utils/helper-string'
import ThemedPressable from 'components/atoms/ThemedPressable'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import ObjectEmployee from 'utils/objects/employee'
import AccountStorage from 'utils/accounts/AccountStorage'
import UserService from 'services/user'
import store from 'services/redux/store'
import { resetData, setData } from 'services/redux/data/actions'
import { resetAuthentication } from 'services/redux/authentication/actions'
import { resetCart } from 'services/redux/cart/actions'
import LoadingComponent from 'components/atoms/Loading'
import HelperPlatform from 'utils/helper-platform'
import { MODES } from 'utils/constants/app-modes';
import { resetManagement } from 'services/redux/management/actions'
import { constantsActive } from 'utils/constants/constants'
import HelperAlerts from 'utils/HelperAlerts'
import { TESTID } from '_shared/config/testID'
import { styles } from 'scenes/home/more/index/styles/styles'
import HomeMoreButton from 'scenes/home/more/index/component/HomeMoreButton'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { createUrl, openUrl } from 'utils/helper-url'
import TimeView from 'scenes/home/more/index/component/TimeView'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'
import useRouteHomeHelper from 'utils/hooks/use-route-home-helper'
import TextDivider from 'components/atoms/TextDivider'

const HomeMoreIndexScene = () => {
	
	useRouteHomeHelper();
	
	const navigation = useNavigation();
	const _messageCount = useSelector( state => {
		return state.data[dataConstants.MESSAGE_COUNT];
	} );
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const isOndmand = ObjectEmployee.isOndmand( _employee );

	const [ updateIsChecking, setUpdateIsChecking ] = useState( false );
	const [ hasMultipleAccounts, setHasMultipleAccounts ] = useState( null );

	const [ isLoggingOut, setIsLoggingOut ] = useState(false);

	const navigateTo = ( route ) => {
		navigation.navigate( route );
	}

	const getHasMultipleAccounts = () => {
		AccountStorage.hasMultipleAccounts().then( ( result ) => {
			setHasMultipleAccounts( result );
		});
	}

	const confirmLogout = () => {
		if( hasMultipleAccounts ){
			HelperAlerts.alert(
				i18n.t( 'alerts.are_you_sure_multi_account.title' ),
				i18n.t( 'alerts.are_you_sure_multi_account.message' ),
				[
					{
						text: i18n.t( 'buttons.cancel' ),
					},
					{
						text: i18n.t( 'buttons.logout' ),
						onPress: logout.bind( this )
					}
				]
			)
		}else{
			HelperAlerts.alert(
				i18n.t( 'alerts.are_you_sure.title' ),
				null,
				[
					{
						text: i18n.t( 'buttons.cancel' ),
					},
					{
						text: i18n.t( 'buttons.logout' ),
						onPress: logout.bind( this )
					}
				]
			);
		}
	}

	const logout = () => {
		setIsLoggingOut( true );

		AccountStorage.clearAccounts().then( () => {
			UserService.logout({
				restart: true,
				resetData: () => {
					return store.dispatch(resetData());
				},
				resetManagement: () => {
					return store.dispatch(resetManagement());
				},
				resetAuthentication: () => {
					return store.dispatch(resetAuthentication());
				},
				resetCart: () => {
					return store.dispatch(resetCart());
				}
			});
		});
	}

	const switchToManagement = () => {
		store.dispatch( setData( dataConstants.MODE, MODES.MANAGEMENT ) );

		if( HelperPlatform.isWeb() ) {
			openUrl( createUrl( MainAppRoutes.MANAGEMENT ) )
		}
	}

	useEffect( () => {
		getHasMultipleAccounts();
	}, [] );

	const buttons = [];

	buttons.push(
		<TextDivider
			key={ HelperString.hash( 'more-section-account' ) }
			text={ i18n.t('pages.more.sections.account') }
		/>
	);

	let iconStyle = [ styles.icon ];

	if( HelperSetting.isYes( settingsConstants.PROFILE_EDITING ) ) {
		buttons.push(
			<HomeMoreButton
		       key={ HelperString.hash( 'more-profile' ) }
		       icon={ <Icon icon={ IconSystemConstants.PERSON } style={ iconStyle } /> }
		       text={ i18n.t( 'titles.more_profile') }
		       onPress={ navigateTo.bind( this, AppRoutes.MORE_PROFILE ) }
		       testID={ TESTID.HOME.MORE.INDEX.PROFILE_BUTTON }
	       />
		)
	}

	if( HelperSetting.isYes( settingsConstants.CREDITS_ENABLED ) ) {
		buttons.push(
			<HomeMoreButton
				key={ HelperString.hash( 'more-credits' ) }
				icon={ <Icon icon={ IconSystemConstants.CLOCK } style={ iconStyle } /> }
				text={ i18n.t( 'titles.credits') }
				onPress={ navigateTo.bind( this, AppRoutes.MORE_CREDITS ) }
			/>
		)
	}

	if( HelperSetting.isYes( settingsConstants.WORKDAY_EDITING ) ) {
		buttons.push(
			<HomeMoreButton
				key={ HelperString.hash( 'more-workdays' ) }
				icon={ <Icon icon={ IconSystemConstants.CLOCK } style={ iconStyle } /> }
				text={ i18n.t( 'titles.more_workdays') }
				onPress={ navigateTo.bind( this, AppRoutes.MORE_WORKDAYS ) }
				testID={ TESTID.HOME.MORE.INDEX.WORKDAYS_BUTTON }
			/>
		)
	}

	// DISABLED
	if( true === false ) {
		buttons.push(
			<HomeMoreButton
				key={ HelperString.hash( 'more-travel-history' ) }
				icon={ <Icon icon={ IconSystemConstants.HOME } style={ iconStyle } />}
				text={ i18n.t( 'titles.more_travel_history') }
				onPress={ navigateTo.bind( this, AppRoutes.MORE_TRAVEL_HISTORY ) }
			/>
		)
	}

	//
	if( HelperSetting.isYes( settingsConstants.PRIVACY_EDITING ) ) {
		buttons.push(
			<HomeMoreButton
				key={ HelperString.hash( 'more-privacy' ) }
				icon={ <Icon icon={ IconSystemConstants.PRIVACY } style={ iconStyle } /> }
				text={ i18n.t( 'titles.more_privacy') }
				onPress={ navigateTo.bind( this, AppRoutes.MORE_PRIVACY ) }
				testID={ TESTID.HOME.MORE.INDEX.PRIVACY_BUTTON }
			/>
		)
	}

	buttons.push(
		<HomeMoreButton
	       key={ HelperString.hash( 'more-inbox' ) }
	       icon={ <Icon icon={ IconSystemConstants.ENVELOPE } style={ iconStyle } checked={ _messageCount > 0 } badge={ _messageCount > 0 ? _messageCount : undefined } badgeStyle={ staticStyles.iconRightTop } /> }
	       text={ i18n.t( 'titles.more_inbox') }
	       onPress={ navigateTo.bind( this, AppRoutes.MORE_INBOX ) }
	       testID={ TESTID.HOME.MORE.INDEX.INBOX_BUTTON }
       />
	)

	buttons.push(
		<TextDivider
			key={ HelperString.hash( 'more-settings-divider', '1' ) }
			text={ i18n.t('pages.more.sections.preferences') }
		/>
	);

	buttons.push(
		<HomeMoreButton
			key={ HelperString.hash( 'more-settings' ) }
			icon={ <Icon icon={ IconSystemConstants.USER_SETTINGS } style={ iconStyle } /> }
			text={ i18n.t( 'titles.more_settings') }
			onPress={ navigateTo.bind( this, AppRoutes.MORE_SETTINGS ) }
			testID={ TESTID.HOME.MORE.INDEX.SETTINGS_BUTTON }
		/>
	)

	buttons.push(
		<HomeMoreButton
			key={ HelperString.hash( 'more-calendar' ) }
			icon={ <Icon icon={ IconSystemConstants.CALENDAR } style={ iconStyle } />}
			text={ i18n.t( 'titles.more_calendar_subscription') }
			onPress={ navigateTo.bind( this, AppRoutes.MORE_CALENDAR_SUBSCRIPTION ) }
			testID={ TESTID.HOME.MORE.INDEX.CALENDAR_SUBSCRIPTION_BUTTON }
		/>
	)

	buttons.push(
		<HomeMoreButton
			key={ HelperString.hash( 'more-about' ) }
			icon={ <Icon icon={ IconSystemConstants.FAVOURITE } style={ iconStyle } />}
			text={ i18n.t( 'titles.more_about_my_office_days') }
			onPress={ navigateTo.bind( this, AppRoutes.MORE_ABOUT ) }
			testID={ TESTID.HOME.MORE.INDEX.ABOUT_BUTTON }
		/>
	)

	buttons.push(
		<TextDivider
			key={ HelperString.hash( 'more-settings', '2' ) }
			text={ i18n.t('pages.more.sections.session') }
		/>
	);

	if( ObjectEmployee.isAdmin( _employee ) && HelperPlatform.isNotWeb() ) {
		buttons.push(
			<HomeMoreButton
				key={ HelperString.hash( 'more-admin' ) }
				icon={ <Icon icon={ IconSystemConstants.MANAGEMENT } style={ iconStyle } /> }
				text={ i18n.t( 'titles.more_management' ) }
				onPress={ switchToManagement.bind( this ) }
			/>
		);
	}

	let enable_multi_account = _.get( _employee, 'enable_multi_account', constantsActive.NO );
	if( ObjectEmployee.isOndmand( _employee ) || hasMultipleAccounts ) {
		enable_multi_account = constantsActive.YES;
	}

	if( enable_multi_account === constantsActive.YES && HelperPlatform.isNotWeb() ) {
		buttons.push(
			<HomeMoreButton
				key={ HelperString.hash( 'more-accounts' ) }
				icon={ <Icon icon={ IconSystemConstants.PERSONS } style={ iconStyle } /> }
				text={ i18n.t( 'titles.more_accounts' ) }
				onPress={ navigateTo.bind( this, AppRoutes.MORE_ACCOUNTS ) }
			/>
		)
	}

	buttons.push(
		<HomeMoreButton
			key={ HelperString.hash( 'more-signout' ) }
			icon={ <Icon icon={ IconSystemConstants.SIGN_OUT } style={ iconStyle } /> }
			text={ i18n.t( 'buttons.logout') }
			onPress={ confirmLogout.bind( this ) }
			destructive
			testID={ TESTID.HOME.MORE.INDEX.LOGOUT_BUTTON }
		/>
	)

	const checkForUpdates = () => {
		setUpdateIsChecking( false );
		const appUpdater = new AppUpdater();

		appUpdater
			.check()
			.then( () => {
				if( appUpdater.updateIsAvailable ) {
					CacheStorage.clearCache( { restart: false } );
					HelperFileCache.drop();

					appUpdater.createAlert({
						callbackStart: setUpdateIsChecking.bind( this, true ),
						callbackSuccess: setUpdateIsChecking.bind( this, false ),
						callbackError: setUpdateIsChecking.bind( this, false )
					});
				} else {
					HelperAlerts.alert(
						i18n.t('update.up_to_date.title'),
						i18n.t('update.up_to_date.message'),
					);

					setUpdateIsChecking( false );
				}
			});
	}

	const openDebug = () => {
		navigateTo( AppRoutes.MORE_DEBUG )
	};

	const openPrivacy = () => {
		openUrl( 'https://www.myofficedays.com/privacy' )
	}
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				topNavigation={ true }
				title={ i18n.t( 'navigation_tabbar.more' ) }
				testID={ TESTID.HOME.MORE.SCREENS.INDEX }>

				<View
					testID={ TESTID.HOME.MORE.INDEX.BUTTONS_VIEW }>
					
					<VStack
						space={ ThemedValues.stackSpace }>
						
						{ buttons }
					</VStack>
				</View>

				<Text style={ styles.customerName}>
					{ HelperSetting.get( settingsConstants.COMPANY_NAME, null ) }
				</Text>
				
				<Pressable onPress={ openPrivacy }>
					<Text style={ styles.privacy}>{ i18n.t( 'ui.privacy_statement' ) }</Text>
				</Pressable>
				
				<Divider style={staticStyles.dividerMarginBottom12MarginLeft20} />
				<Text style={ styles.modVersion}>{ i18n.t( 'app_name' ) } { HelperVersion.get() }</Text>
				
				{ HelperPlatform.isNotWeb() && (
					<Choose>
						<When condition={ !updateIsChecking }>
							<ThemedPressable onPress={ checkForUpdates }>
								<Text style={ styles.modVersionUpdate}>{ i18n.t('update.check') }</Text>
							</ThemedPressable>
						</When>
						<Otherwise>
							<View style={ styles.modVersionUpdateProgress }>
								<Progress.Bar
									height={ 4 }
									width={ 200 }
									animated={ true }
									color={ colorList.ORANGE.light }
									borderWidth={ 1 }
									indeterminate={ true }
								/>
							</View>
						</Otherwise>
					</Choose>
				)}
				
				<TimeView />

				{ (isOndmand || HelperDevelopment.isDev() || HelperDevelopment.isTestWeb() || HelperDevelopment.isTestOTA()) && (
					<>
						<Divider style={staticStyles.dividerMarginBottom12MarginLeft20} />
						<ThemedPressable
							onPress={ openDebug }>

							<Text style={ styles.debug }>{ i18n.t( 'debug_ui.title' ) }</Text>
						</ThemedPressable>
					</>
				) }
			</ThemedLayout>

			{ isLoggingOut && (
				<LoadingComponent
					fullscreen={ true }
					size={ 'l' }
				/>
			)}
		</ThemedSafeAreaComponentTop>
	);
}



const staticStyles = StyleSheet.create({
	iconRightTop: {
		right: -5,
		top: -5,
	},
	dividerMarginBottom12MarginLeft20: {
		marginBottom: 12,
		marginLeft: 20,
		marginRight: 20,
	},
});

export default HomeMoreIndexScene;
